import { Result } from '@standardnotes/domain-core';
import { isKeySystemRootKey, } from '@standardnotes/models';
import { isItemsKey, isKeySystemItemsKey } from '@standardnotes/encryption';
export class DecryptBackupPayloads {
    constructor(encryption, _determineKeyToUse, logger) {
        this.encryption = encryption;
        this._determineKeyToUse = _determineKeyToUse;
        this.logger = logger;
    }
    async execute(dto) {
        const results = [];
        for (const encryptedPayload of dto.payloads) {
            try {
                const key = this._determineKeyToUse
                    .execute({
                    payload: encryptedPayload,
                    recentlyDecryptedKeys: dto.recentlyDecryptedKeys,
                    keyParams: dto.keyParams,
                    rootKey: dto.rootKey,
                })
                    .getValue();
                if (!key) {
                    results.push(encryptedPayload.copy({
                        errorDecrypting: true,
                    }));
                    continue;
                }
                if (isItemsKey(key) || isKeySystemItemsKey(key)) {
                    const decryptedPayload = await this.encryption.decryptSplitSingle({
                        usesItemsKey: {
                            items: [encryptedPayload],
                            key: key,
                        },
                    });
                    results.push(decryptedPayload);
                }
                else if (isKeySystemRootKey(key)) {
                    const decryptedPayload = await this.encryption.decryptSplitSingle({
                        usesKeySystemRootKey: {
                            items: [encryptedPayload],
                            key: key,
                        },
                    });
                    results.push(decryptedPayload);
                }
                else {
                    const decryptedPayload = await this.encryption.decryptSplitSingle({
                        usesRootKey: {
                            items: [encryptedPayload],
                            key: key,
                        },
                    });
                    results.push(decryptedPayload);
                }
            }
            catch (e) {
                results.push(encryptedPayload.copy({
                    errorDecrypting: true,
                }));
                this.logger.error('Error decrypting payload', encryptedPayload, e);
            }
        }
        return Result.ok(results);
    }
}
